import { IIconBase } from '..'

const alertTriangleIcon = ({
  color = '#000000',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      version='1.0'
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 512.000000 512.000000'
      preserveAspectRatio='xMidYMid meet'
    >
      <g
        transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
        fill={color}
        stroke='none'
      >
        <path
          d='M2482 4869 c-213 -27 -403 -157 -549 -374 -63 -94 -1823 -3142 -1854
        -3211 -52 -114 -73 -216 -73 -349 0 -180 47 -322 144 -440 121 -146 274 -222
        495 -245 120 -13 3599 -13 3760 0 66 5 153 19 193 30 342 96 552 393 515 728
        -12 110 -49 227 -101 322 -83 151 -1789 3111 -1828 3170 -87 134 -224 259
        -347 315 -104 48 -240 69 -355 54z m221 -342 c71 -32 164 -120 221 -207 95
        -144 1821 -3157 1845 -3219 20 -54 25 -84 25 -166 0 -86 -3 -108 -25 -155 -51
        -110 -167 -187 -318 -210 -43 -7 -709 -10 -1951 -8 l-1885 3 -57 21 c-118 45
        -199 128 -229 235 -20 73 -14 185 15 271 18 55 263 487 927 1634 496 857 915
        1579 932 1604 141 204 325 277 500 197z'
        />
        <path
          d='M2415 3442 c-65 -22 -111 -55 -133 -95 -14 -27 -16 -55 -14 -182 3
        -170 37 -589 86 -1058 37 -355 36 -353 117 -395 85 -45 207 -12 244 65 12 24
        32 230 77 769 56 669 60 741 47 778 -18 50 -79 99 -153 120 -73 21 -207 20
        -271 -2z'
        />
        <path
          d='M2450 1456 c-218 -115 -137 -438 110 -439 207 -1 309 257 159 400
        -71 67 -185 84 -269 39z'
        />
      </g>
    </svg>
  )
}

export default alertTriangleIcon
